import type { MutableRefObject, SyntheticEvent } from 'react';
import { useCallback } from 'react';

interface UseOnClickTempToggleOptions {
	callback: () => void;
	offCallback?: () => void;
	ref: MutableRefObject<HTMLElement | null>;
}

/**
 * A click handler which calls a function and calls it again
 * once the user's mouse leaves the element
 */
export function useOnClickTempToggle(options: UseOnClickTempToggleOptions) {
	const { callback, offCallback = callback, ref } = options;

	return useCallback(
		({
			target,
		}:
			| SyntheticEvent<HTMLElement | SVGSVGElement>
			| { target: HTMLElement | SVGSVGElement | EventTarget }) => {
			ref.current = target as HTMLElement;
			callback();
			target.addEventListener('mouseleave', offCallback, {
				once: true,
			});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[callback, offCallback]
	);
}
